import React from "react";
import { Container, Row } from "react-bootstrap";
import Marquee from "react-fast-marquee";
import ClickableBadge from "./ClickableBadge"; // adjust path as needed
import { Link } from "gatsby";

const Accreditations = ({ logos }) => {
  return (
    <section className="trusted-by py-5 pt-lg-7">
      <Container fluid>
        <Row className="justify-content-center">
          <Marquee pauseOnHover={true} gradient={false} speed={20}>
            <div className="me-5">
              <ClickableBadge />
            </div>
            {logos.map((item, i) => (
              <>
                {item.link ? (
                  <Link to={item.link} target="_blank">
                    <img
                      src={item.image.sourceUrl}
                      style={{ maxWidth: "160px" }}
                      alt={item.image.altText}
                      key={i}
                      className="me-5"
                    />
                  </Link>
                ) : (
                  <img
                    src={item.image.sourceUrl}
                    style={{ maxWidth: "160px" }}
                    alt={item.image.altText}
                    key={i}
                    className="me-5"
                  />
                )}
              </>
            ))}

            {/* <iframe
							referrerpolicy="origin"
							frameborder="0"
							scrolling="no"
							allowTransparency="true"
							width="250"
							height="120"
							src="https://cdn.yoshki.com/badge-bics.html"
							style="border:0;margin:0;padding:0;background-color:transparent;"
						></iframe> */}
          </Marquee>
        </Row>
      </Container>
    </section>
  );
};

export default Accreditations;
